// JS carga de provincias form direcciones

$(document).ready(function(){
    // variables
    const province = `
        <option value="AGS">Aguascalientes</option>
        <option value="BC">Baja California</option>
        <option value="BCS">Baja California Sur</option>
        <option value="CAMP">Campeche</option>
        <option value="CHIS">Chiapas</option>
        <option value="CHIH">Chihuahua</option>
        <option value="DF">Ciudad de México</option>
        <option value="COAH">Coahuila de Zaragoza</option>
        <option value="COL">Colima</option>
        <option value="DGO">Durango</option>
        <option value="GRO">Estado de Guerrero</option>
        <option value="HGO">Estado de Hidalgo</option>
        <option value="MEX">Estado de México</option>
        <option value="GTO">Guanajuato</option>
        <option value="JAL">Jalisco</option>
        <option value="MICH">Michoacán</option>
        <option value="MOR">Morelos</option>
        <option value="NAY">Nayarit</option>
        <option value="NL">Nuevo León</option>
        <option value="OAX">Oaxaca</option>
        <option value="PUE">Puebla</option>
        <option value="QRO">Querétaro</option>
        <option value="Q ROO">Quintana Roo</option>
        <option value="SLP">San Luis Potosí</option>
        <option value="SIN">Sinaloa</option>
        <option value="SON">Sonora</option>
        <option value="TAB">Tabasco</option>
        <option value="TAMPS">Tamaulipas</option>
        <option value="TLAX">Tlaxcala</option>
        <option value="VER">Veracruz</option>
        <option value="YUC">Yucatán</option>
        <option value="ZAC">Zacatecas</option>
    `

    // acciones
    $('.js-province__action').each(function () {
        initPrint($(this))
    })

    $('body').on('change', '.js-province__action', function() {
        initPrint($(this))
    })

    // funciones
    function initPrint(action){
        $('.js-province__provinces').each(function () {
            if (action.data('province__id') == $(this).data('province__id')) {
                const items = action.find(':selected').data('provinces')
                
                $(this).html(' ')
                $(this).append(`
                    <option disabled="">Estado</option>
                `)

                if (action.data('province__val') == 'México' || action.data('province__val') == 'Mexico') {
                    action.val('Mexico')
                    $(this).append(province)
                }else{
                    items.forEach(item => {
                        $(this).append(`
                            <option data-alternate-values="[${item[0]}]" value="${item[1]}">${item[1]}</option>
                        `)
                    })
                }

                if ( $(this).data('default') ) {
                    const select_self = $(this)
                    const val_self = $(this).data('default')

                    const options = $(this).find('option')
                    options.each( function(){
                        if( $(this).html() == val_self ){
                            select_self.val( $(this).val() )
                        }
                    })

                }
            }
        })
    }
})
    


